import ExtendableError from 'es6-error'

/**
 * BaseError to extend application custom errors
 * @extends ExtendableError
 */
export default class BaseError extends ExtendableError {
  /**
   * checks if error is instance of any error type
   * @param {Error|[Error]} ErrorClass - Error class or array Error classes to check
   * @return {Boolean} true if error is contempled by passed classes
   */
  is(ErrorClass) {
    if (Array.isArray(ErrorClass)) {
      return ErrorClass.some(Class => this.is(Class))
    }
    return this instanceof ErrorClass
  }
}
